import { createSelector } from "reselect";
import { adminSectionSelector } from "../../admin_section_selector";

export const adminRulesSelectedOrganizationIdSelector = createSelector(
  adminSectionSelector,
  adminsSection => {
    return adminsSection.rulesTab.selectedOptions.organizationId;
  }
);
